import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilderService} from '../shared/services/databaseServices/formBuilderService/form-builder.service';
import {FormItem} from '../shared/classes/FormItem';
import {EditService} from '../shared/services/editService/edit.service';
import {FormBuilder, Validators} from '@angular/forms';
import {faExternalLinkAlt, faSave, faTrash} from '@fortawesome/free-solid-svg-icons';
import {FormsService} from '../shared/services/databaseServices/forms/forms.service';
import {Form} from '../shared/classes/Form';
import {Races} from '../races/Races';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {Race} from '../shared/classes/Race';
import {TranslatePipe} from '../translate.pipe';

@Component({
  selector: 'app-form-builder-detail',
  templateUrl: './form-builder-detail.component.html',
  styleUrls: ['./form-builder-detail.component.css'],
  providers: [TranslatePipe]
})
export class FormBuilderDetailComponent implements OnInit {

  private static NEW_ID = 'new';

  id = undefined;
  isNew = false;
  formItems: FormItem[] = undefined;
  form: Form;
  faSave = faSave;
  faTrash = faTrash;
  faLink = faExternalLinkAlt;
  formName = undefined;
  formId = undefined;
  loadRaceData = true;
  races: Race[] = [];
  selectRace: Race = undefined;
  urlPrefix = '';

  public formForm = this.formBuilder.group({
      url: ['', [Validators.required]],
      race: [ '' , [Validators.required]],
      cash: ['', []],
      card: ['', []],
      fio: ['', []],
      account: ['', []]
  });

  displayedColumns: string[] = ['visibleText', 'type', 'required', 'visible', 'enum'];

  header = [
    {
      defName: 'visibleText',
      translation: 'settingPage.formBuilder.formBuilder.name',
      elem: 'visibleText'
    },
    {
      defName: 'type',
      translation: 'settingPage.formBuilder.formBuilder.type',
      elem: 'type'
    },
    {
      defName: 'required',
      translation: 'settingPage.formBuilder.formBuilder.required',
      elem: 'required'
    },
    {
      defName: 'visible',
      translation: 'settingPage.formBuilder.formBuilder.visible',
      elem: 'visible'
    },
    {
      defName: 'enum',
      translation: 'settingPage.formBuilder.formBuilder.enum',
      elem: 'enum'
    }
  ];

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private formBuilderService: FormBuilderService,
              private editService: EditService,
              private formBuilder: FormBuilder,
              private formsService: FormsService,
              private racesService: RacesService,
              private translate: TranslatePipe) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.isNew = this.id === FormBuilderDetailComponent.NEW_ID;
    if (this.isNew) {
      this.loadFormItems();
      this.loadRaces();
      this.formForm.get('url').enable();
    } else {
      this.formsService.getOneForm(this.id).then(data => {
        this.formForm.get('url').disable();
        this.formName = data.data().url;
        this.formId = data.id;
        this.formForm.patchValue({url: data.data().url,
          cash: data.data().payMethod.cash,
          card: data.data().payMethod.card,
          fio: data.data().payMethod.fio,
          account: data.data().payMethod.account !== undefined ? data.data().payMethod.account: ''});

        data.data().race.get().then( raceData => {
          this.selectRace = raceData.data();
          this.selectRace.id = raceData.id;
          this.formForm.patchValue( {race: this.selectRace.id } );
        });

        this.loadFormItems(data.data().formItems);
        this.loadRaces();
      });
    }
  }

  resetAccount() {
    this.formForm.patchValue({account: ''});
  }

  loadRaces() {
    this.racesService.getRaces().then( data => {
      data.forEach( item => {
        const race: Race = new Race();
        race.id = item.id;
        race.name = item.data().name;
        // race.organizer = item.data().poradatel;
        race.dateStart = item.data().dateStart;

        this.races.push(race);
      });
    });
  }

  loadFormItems(existingFormItems = []) {
    this.formBuilderService.getFormItems().then(data => {
      this.formItems = [];
      data.forEach(item => {
        const formItem: FormItem = new FormItem();
        formItem.key = item.id;
        formItem.required = item.data().required;
        formItem.requiredDefault = item.data().requiredDefault;
        formItem.visibleText = this.translate.transform(`settingPage.formBuilder.formBuilder.item.${item.data().visibleText}`);
        formItem.visible = item.data().visible;
        formItem.visibleDefault = item.data().visibleDefault;
        formItem.type = item.data().type;
        formItem.enum = item.data().enum;
        this.formItems.push(formItem);
      });
      this.formItems = this.formItems.map(item => {
        item.type.get().then(type => {
          item.type = type.data().type;
          if (item.type === 'enum' && item.enum !== undefined) {
            item.enum.get().then( enumItems => {
              item.enum = enumItems.data().type.map( i => {
                return this.translate.transform(`settingPage.formBuilder.formBuilder.item.${i}`);
              });
            });

          } else {
            item.enum = [];
          }
          return item;
        });
        return item;
      });

      this.formItems.forEach( item => {
        if(existingFormItems.map(formItem => formItem.key).indexOf(item.key) === -1){
          existingFormItems.push(item);
        }
      });
      this.formItems = existingFormItems;
    });
  }

  isEdit() {
    return this.editService.editable;
  }

  create() {
    if(!this.isNew){
      this.formForm.value.url = this.formName;
    }

    const payMethod = {
      cash: this.formForm.value.cash,
      card: this.formForm.value.card,
      fio: this.formForm.value.fio,
      account: this.formForm.value.account
    };

    this.formsService.createForms(this.formForm.value.url, this.formForm.value.race, this.formItems, payMethod).then( () => {

      this.router.navigate(['/admin/settings/forms']);
    })
      .catch( err => {
        console.dir(err);
      });
  }

  remove(id){
    this.formsService.deleteForm(id).then( () => {
      this.router.navigate(['/admin/settings/forms']);
    }).catch( err => {
      console.dir(err);
    })
  }

  openUrl(){
    const url = `${this.urlPrefix}/showForm/${this.formForm.get('url').value}`;
    this.router.navigate([]).then( result => { window.open(url, '_blank'); });
  }

  private setPrefixUrl(){

    this.urlPrefix = location.href;
    const protocol = this.urlPrefix.substr(0, this.urlPrefix.indexOf(':'));
    this.urlPrefix = this.urlPrefix.substr(this.urlPrefix.indexOf(':') + 3);
    this.urlPrefix = `${protocol}://${this.urlPrefix.substr(0, this.urlPrefix.indexOf('/'))}`;
  }

}
